import React, { useContext, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { userContext } from "src/context/UserContext";
import { url } from "src/helpers";
import NewHeader from "src/New Codes/components/NewHeader";

function LoginPage() {
  const { setUser, setLoad } = useContext(userContext);
  const [mode, setMode] = useState("password"); // "password" | "otp"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [emailNotice, setEmailNotice] = useState("");

  const history = useHistory();

  React.useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
    return () => clearTimeout(timer);
  }, [resendCooldown]);

  function switchMode(next) {
    if (next === mode) return;
    setMode(next);
    setOtpSent(false);
    setOtp("");
    setEmailNotice("");
    setPassword("");
  }

  function loginSuccess(data) {
    setUser({
      token: data?.token,
      ...data?.logged_data,
    });
    history.push("/dashboard");
  }

  async function loginWithPassword(e) {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Email and password are required");
      return;
    }
    setLoad(true);
    try {
      const response = await fetch(url + "login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      setLoad(false);
      if (data?.status === 200) {
        loginSuccess(data);
      } else if (data?.status === 402) {
        toast.error(data?.message || "Please activate your account first");
      } else {
        toast.error(data?.message || "Incorrect email or password");
      }
    } catch (err) {
      setLoad(false);
      toast.error("Oops something went wrong!");
    }
  }

  async function sendOtp(e) {
    e.preventDefault();
    if (!email) {
      toast.error("Email is required");
      return;
    }
    setEmailNotice("");
    setLoad(true);
    try {
      const response = await fetch(url + "email-otp/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      setLoad(false);
      if (data?.email_verification_required) {
        setEmailNotice(data?.message || "Please verify your email before signing in.");
      } else if (data?.status === 200) {
        toast.success(data?.message || "Verification code sent");
        setOtpSent(true);
        setResendCooldown(60);
      } else if (data?.status === 429) {
        toast.warning(data?.message || "Please wait before requesting another code");
      } else {
        toast.error(data?.message || "Failed to send verification code");
      }
    } catch (err) {
      setLoad(false);
      toast.error("Oops something went wrong!");
    }
  }

  async function verifyOtp(e) {
    e.preventDefault();
    if (!otp) {
      toast.error("Please enter the verification code");
      return;
    }
    setLoad(true);
    try {
      const response = await fetch(url + "email-otp/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });
      const data = await response.json();
      setLoad(false);
      if (data?.status === 200) {
        loginSuccess(data);
      } else {
        toast.error(data?.message || "Invalid verification code");
      }
    } catch (err) {
      setLoad(false);
      toast.error("Oops something went wrong!");
    }
  }

  const otpFormSubmitHandler = otpSent ? verifyOtp : sendOtp;

  return (
    <>
      <NewHeader />
      <div className="custom_signup_new split_layout login-split-layout">
        {/* Left Side: Hero Section (reuses the Signup page's visual language) */}
        <div className="signup-hero-section">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo mb-4">
              <i className="fa fa-truck-moving hero-logo-icon"></i>
            </div>
            <h1 className="hero-title">Welcome back to <br /><span>Beba Mzigo</span></h1>
            <p className="hero-description">
              Sign in to post a shipment, bid on a load, or manage your fleet - everything you need
              to keep cargo moving across Kenya.
            </p>
            <div className="hero-features">
              <div className="feature-item"><i className="fa fa-check-circle"></i> Verified Transporters</div>
              <div className="feature-item"><i className="fa fa-check-circle"></i> Secure Escrow Payments</div>
              <div className="feature-item"><i className="fa fa-check-circle"></i> Real-time Tracking</div>
            </div>
          </div>
        </div>

        {/* Right Side: Form Section */}
        <div className="signup-form-section">
          <div className="form-inner-container">
            <div className="form-header mb-4">
              <h2>Welcome Back</h2>
              <p>Sign in to continue to your account</p>
            </div>

            {/* Login mode toggle */}
            <div className="login-mode-toggle mb-4">
              <button
                type="button"
                onClick={() => switchMode("password")}
                className={`login-mode-btn ${mode === "password" ? "active" : ""}`}
              >
                <i className="fa fa-lock"></i> Password
              </button>
              <button
                type="button"
                onClick={() => switchMode("otp")}
                className={`login-mode-btn ${mode === "otp" ? "active" : ""}`}
              >
                <i className="fa fa-key"></i> Email OTP
              </button>
            </div>

            {mode === "password" ? (
              <form onSubmit={loginWithPassword}>
                <div className="mb-3">
                  <label className="custom-label">Email Address</label>
                  <div className="input-group-custom">
                    <span className="input-icon"><i className="fa fa-envelope"></i></span>
                    <input
                      type="email"
                      className="custom-input with-icon"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="name@company.com"
                      autoComplete="username"
                    />
                  </div>
                </div>

                <div className="mb-2">
                  <label className="custom-label">Password</label>
                  <div className="input-group-custom">
                    <span className="input-icon"><i className="fa fa-lock"></i></span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="custom-input with-icon"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="••••••••"
                      autoComplete="current-password"
                    />
                    <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                      <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                    </span>
                  </div>
                </div>

                <div className="w-100 d-flex justify-content-end mb-3">
                  <Link to="/ForgetPasswordEmail" className="forgot-link">
                    Forgot password?
                  </Link>
                </div>

                <button type="submit" className="btn-signup-full">LOGIN</button>
              </form>
            ) : (
              <form onSubmit={otpFormSubmitHandler}>
                <div className="mb-3">
                  <label className="custom-label">Email Address</label>
                  <div className="input-group-custom">
                    <span className="input-icon"><i className="fa fa-envelope"></i></span>
                    <input
                      type="email"
                      className="custom-input with-icon"
                      required
                      disabled={otpSent}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="name@company.com"
                    />
                  </div>
                </div>

                {emailNotice && (
                  <div className="login-inline-notice">
                    <i className="fa fa-envelope-o"></i> {emailNotice}
                  </div>
                )}

                {otpSent && !emailNotice && (
                  <div className="mb-2">
                    <label className="custom-label">Verification Code</label>
                    <div className="input-group-custom">
                      <span className="input-icon"><i className="fa fa-key"></i></span>
                      <input
                        type="text"
                        className="custom-input with-icon"
                        required
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter Verification Code"
                      />
                    </div>
                    <div className="text-muted small mt-2">
                      We sent a code to your email. Enter it above.
                    </div>
                  </div>
                )}

                <button type="submit" className="btn-signup-full mt-3">
                  {otpSent ? "VERIFY & SIGN IN" : "SEND CODE"}
                </button>

                {otpSent && (
                  <div className="w-100 d-flex justify-content-center mt-3">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      disabled={resendCooldown > 0}
                      onClick={sendOtp}
                    >
                      {resendCooldown > 0 ? `Resend code in ${resendCooldown}s` : "Resend code"}
                    </button>
                  </div>
                )}
              </form>
            )}

            <p className="text-center mt-4 text-muted">
              Don't have an account? <Link to="/signup" className="forgot-link font-weight-bold">Sign Up</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
